import { OperationTypeStatus } from 'app/dataTypes/cafeteria/compensation/transactions'


export const getStatusColor = (status: OperationTypeStatus) => {
  if (status === OperationTypeStatus.Accrual) return 'green'
  if (status === OperationTypeStatus.CancellationAccrual) return 'red'
  if (status === OperationTypeStatus.WithdrawalCurrentAccount) return 'red'
  if (status === OperationTypeStatus.WithdrawalPersonalAccount) return 'red'
  if (status === OperationTypeStatus.CancellationWithdrawalPersonalAccount) return 'green'

  return 'gainsboro'
}
